// extracted by mini-css-extract-plugin
export default {"globalcombox":"ComboBoxComp_globalcombox__vQ7A4"};